import React, { useMemo } from 'react'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import { Link, Outlet, useParams } from 'react-router-dom'

import Button from '../../components/basics/Button/Button'
import CommentsList from '../../components/comments/CommentsList/CommentsList'
import { useGroup } from '../../state/entities'
import useRoutes from '../../state/useRoutes'

import styles from './GroupCommentPage.module.scss'

/**********************************************************************
 * GroupCommentPage
 **********************************************************************/
export default React.memo(function GroupCommentPage() {
  const { t } = useTranslation()
  const routes = useRoutes()

  const { uuid, commentUuid } = useParams()

  const { group } = useGroup(uuid)
  const rootUuid = useMemo(() => ({ groupUuid: uuid! }), [uuid])

  return (
    <>
      <article className={classnames(styles.GroupCommentPage, { skeleton: group.isDummy })}>
        <header>
          <h1>{group.name}</h1>
          <Button small component={Link} to={routes.manageGroup.url({ uuid: uuid! })}>
            {t('group.cta back to group')}
          </Button>
        </header>

        <main>
          <CommentsList commentUuid={commentUuid!} rootUuid={rootUuid} root={group} />
        </main>
      </article>
      <Outlet />
    </>
  )
})

/**********************************************************************
 * GroupCommentPageBreadcrumb
 **********************************************************************/
export function GroupCommentPageBreadcrumb() {
  const { t } = useTranslation()
  const { uuid, commentUuid } = useParams()
  const routes = useRoutes()
  return (
    <Link to={routes.groupComment.url({ uuid: uuid!, commentUuid: commentUuid! })}>{t('comment.field comments')}</Link>
  )
}
